export default __webpack_public_path__ + "static/media/hot_bg2.a69452d4.jpg";